export default __webpack_public_path__ + "static/media/eshop.e7f93828.PNG";